import { default as useMixpanel } from "mixpanel-browser";
import { genericConfig } from '../config'

const { MIXPANEL_TOKEN, MIXPANEL_TMN_TOKEN } = genericConfig

useMixpanel.init(MIXPANEL_TOKEN);
useMixpanel.init(MIXPANEL_TMN_TOKEN, {}, "TMN");

export const mixpanel = useMixpanel;
